import axios from 'axios'
//import qs from 'qs'
import store from '@/store/store'

const der_api = process.env.VUE_APP_DER_API

// interceptor on request
axios.interceptors.request.use(function (request) {
  if (request.url.startsWith('http://geoserverhml.eparana.parana') ||
    request.url.startsWith('http://geoserverdes.eparana.parana') ||
    request.url.startsWith('https://geoserver.pr.gov.br')) { // FIXME
    return request
  }

  if (store.getters.getJwtToken) {
    request.headers.Authorization = `Bearer ${store.getters.getJwtToken}`
  }

  return request
},
function (error) {
  return Promise.reject(error)
})

// interceptor on response
axios.interceptors.response.use(function (response) {
  return response
},
function (error) {
  if (error === 'Error: Network Error') {
    if (error.response === undefined) {
      var networkError = { response: { data: { message: 'Algum recurso necessário para execução desta funcionalidade encontra-se indisponível.' } } }
      error = networkError
    }
  }

  if (error.response !== undefined && error.response.status === 403) {
    var permissionError = { response: { data: { message: '403 - Sem acesso a alguns recursos desta funcionalidade.' } } }
    error = permissionError
  }

  if (error.response !== undefined && error.response.status === 404) {
    var permiError = { response: { data: { message: '404 - Algum recurso necessário para execução desta funcionalidade não foi encontrado.' } } }
    error = permiError
  }

  // if (error.response != undefined && 500 === error.response.status) {
  //   var permissionError = {response : {data : error.response.data}}
  //   error = permissionError
  // }

  return Promise.reject(error)
})

export const cidade = {
  getNomes () {
    return axios.get(`${der_api}/cidade/nomes`)
  }
}

export const cop = {
  getLotes () {
    return axios.get(`${der_api}/cop/lotes`)
  },
  getTrechos () {
    return axios.get(`${der_api}/cop/trechos`)
  }
}

export const copControleContratos = {
  getSRE () {
    return axios.get(`${der_api}/cop-controle-contratos/sre`)
  },
  getLotes () {
    return axios.get(`${der_api}/cop-controle-contratos/lotes`)
  }
}

export const cremep = {
  getLotes () {
    return axios.get(`${der_api}/cremep/lotes`)
  },
  getTrechos () {
    return axios.get(`${der_api}/cremep/trechos`)
  }
}

export const cremepControleContratos = {
  getLotes () {
    return axios.get(`${der_api}/cremep-controle-contratos/lotes`)
  }
}

export const denominacaoPonte = {
  getNome () {
    return axios.get(`${der_api}/denominacao-ponte/nome`)
  }
}

export const denominacaoRodovia = {
  getSRE () {
    return axios.get(`${der_api}/denominacao-rodovia/sre`)
  },
  getNome () {
    return axios.get(`${der_api}/denominacao-rodovia/nome`)
  }
}

export const desapropriacao = {
  getNome () {
    return axios.get(`${der_api}/desapropriacao/nome`)
  },
  getSid () {
    return axios.get(`${der_api}/desapropriacao/sid`)
  }
}

export const escritorioRegional = {
  getNomes () {
    return axios.get(`${der_api}/escritorio-regional/nomes`)
  }
}

export const faixaDominio = {
  getLotes () {
    return axios.get(`${der_api}/faixa-dominio/lotes`)
  },
  getTrechos () {
    return axios.get(`${der_api}/faixa-dominio/trechos`)
  }
}

export const povoado = {
  getNomes () {
    return axios.get(`${der_api}/povoado/nomes`)
  }
}

export const projetoObra = {
  getContrato () {
    return axios.get(`${der_api}/projeto-obra/contrato`)
  },
  getOrigem () {
    return axios.get(`${der_api}/projeto-obra/origem`)
  },
  getStatus () {
    return axios.get(`${der_api}/projeto-obra/status`)
  }
}

export const obrasDt = {
  getSituacao () {
    return axios.get(`${der_api}/obra-dt/situacao`)
  },
  getRodovia () {
    return axios.get(`${der_api}/obra-dt/rodovia`)
  },
  getContrato () {
    return axios.get(`${der_api}/obra-dt/contrato`)
  },
  getSup () {
    return axios.get(`${der_api}/obra-dt/sup`)
  }
}

export const projetosDt = {
  getObjeto () {
    return axios.get(`${der_api}/projeto-dt/objeto`)
  },
  getRodovia () {
    return axios.get(`${der_api}/projeto-dt/rodovia`)
  },
  getContrato () {
    return axios.get(`${der_api}/projeto-dt/contrato`)
  },
  getSup () {
    return axios.get(`${der_api}/projeto-dt/sup`)
  }
}

export const superintendencia = {
  getNomes () {
    return axios.get(`${der_api}/superintendencia/nomes`)
  }
}

export const areasDeGestao = {
  getNumeros () {
    return axios.get(`${der_api}/area-de-gestao/lista-numeros`)
  }
}

export const restricaoDeTrafego = {
  getLimites () {
    return axios.get(`${der_api}/restricao-de-trafego/lista-limites`)
  }
}

export const ponte = {
  getNomes () {
    return axios.get(`${der_api}/ponte/nomes`)
  },
  getRodovias () {
    return axios.get(`${der_api}/ponte/rodovias`)
  }
}

export const proxy = {
  geoProxy (params) {
    return axios.get(`${der_api}/geoProxy/geoserver`, {
      params: params
    })
  }
}

export const novosProgramasConservacao = {
  getLotes () {
    return axios.get(`${der_api}/novos-programas-conservacao/lotes`)
  },
  getTrechos () {
    return axios.get(`${der_api}/novos-programas-conservacao/trechos`)
  }
}

export const antigoAnelIntegracao = {
  getLotes () {
    return axios.get(`${der_api}/antigo-anel-integracao/lotes`)
  },
  getTrechos () {
    return axios.get(`${der_api}/antigo-anel-integracao/trechos`)
  }
}

export const condicaoMalha = {
  getTrechos () {
    return axios.get(`${der_api}/condicao-malha/trechos`)
  }
}

export default {
  /*getImagens (params) {
    return axios.get(`${der_api}/imagens/geojson`, {
      params: params,
      paramsSerializer: params => qs.stringify(params, {
        arrayFormat: 'repeat',
        skipNulls: true
      })
    })
  }*/
  getImagens (rodovia) {
    return axios.get(`${der_api}/imagens/geojson?rodovia=${rodovia}`)
  },

  getImagens2022 (rodovia) {
    return axios.get(`${der_api}/imagens/geojson2022?rodovia=${rodovia}`)
  },

  getListaRodovias () {
    return axios.get(`${der_api}/imagens/listaRodovias`)
  },

  getListaRodovias2022 () {
    return axios.get(`${der_api}/imagens/listaRodovias2022`)
  },

  getTrechos () {
    return axios.get(`${der_api}/sistema-rodoviario/trechos`)
  },

  getRodovias () {
    return axios.get(`${der_api}/sistema-rodoviario/rodovias`)
  },

  getSemanasPista () {
    return axios.get(`${der_api}/programacao-semanal-servicos/semanaPista`)
  },

  getSemanasFaixa () {
    return axios.get(`${der_api}/programacao-semanal-servicos/semanaFaixa`)
  },

  getSemanasProseg () {
    return axios.get(`${der_api}/programacao-semanal-servicos/semanaProseg`)
  }
}